import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormLabel,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  TableCell,
  TableRow,
  TextField,
  styled,
  tableCellClasses,
} from "@mui/material";
import { useRef } from "react";
import React, { useEffect, useState } from "react";
import { FormControlLabel, Grid, Typography } from "@mui/material";
import {
  CheckoutDetail,
  DraftOrderAddress,
  DraftOrderRequest,
  PartsCheckoutDetail,
  PartsCheckoutInitialValues,
  PartsCheckoutValidationSchema,
} from "../../../models/features/Gravity/CheckoutDetail";
import {
  useAddTransactionHistoryMutation,
  useGetTransactionTokenMutation,
} from "../../../redux/reducer/features/Customer/CustomerSlice";
import { ErrorMessage, Form, Formik, FormikProps } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import {
  removeCart,
  setOpenCheckout,
  useCalculateTaxMutation,
  useCreateShoppingPortalOrderMutation,
  useAddPayPalTransactionHistoryMutation,
  useGetPayPalClientIdMutation,
} from "../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import {
  Address,
  TargetOrderRequest,
  TaxLines,
} from "../../../models/features/ShoppingPortal/ShoppingPortalOrderHookRequest";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { getFullName } from "../../../services/utilities/utility";
import PhoneInput from "react-phone-input-2";

declare const emergepay: any;
interface CheckOutDialogProps {}

export const CheckOutDialog: React.FunctionComponent<
  CheckOutDialogProps
> = () => {
  const dispatch = useDispatch();
  const cart = useSelector(
    (state: AppState) => state.shoppingPortalReducer.cart
  );
  const dmsLocations = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.dmsLocations
  );
  const shippingCharges = useSelector((state: AppState) =>
    state.shoppingPortalReducer.portalSettings?.setting.shippingCharge.toString()
  );
  const { customerData } = useSelector((state: AppState) => state.authReducer);
  const setupId = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting.dmsSetupId
  );
  const paymentMethod = useSelector(
    (state: AppState) => state.shoppingPortalReducer.portalSettings?.paymentType
  );
  const openCheckout = useSelector(
    (state: AppState) => state.shoppingPortalReducer.openCheckout
  );

  const [calculateTaxMutation, calculateTaxMutationResult] =
    useCalculateTaxMutation();
  const [createOrderMutation, createOrderMutationResult] =
    useCreateShoppingPortalOrderMutation();
  const [getClientIdMutation, getClientIdMutationResult] =
    useGetPayPalClientIdMutation();
  const [getTransactionTokenMutation, getTransactionTokenMutationResult] =
    useGetTransactionTokenMutation();
  const [addTransactionHistoryMutation, addTransactionHistoryMutationResult] =
    useAddTransactionHistoryMutation();

  const [
    addPayPalTransactionHistoryMutation,
    addPayPalTransactionHistoryMutationResult,
  ] = useAddPayPalTransactionHistoryMutation();

  const [taxResponse, setTaxResponse] = React.useState<any>(null);
  const [partsCheckoutDetail, setPartsCheckoutDetail] = React.useState<any>(
    PartsCheckoutInitialValues
  );
  const [pickupLocationData, setPickupLocationData] = React.useState<any>({});
  const [errorMessage, setErrorMessage] = React.useState("");
  const [customerInformation, setCustomerInformation] =
    React.useState<PartsCheckoutDetail>();
  const [taxAmount, setTaxAmount] = React.useState<number>(0);
  const [amountToPay, setAmountToPay] = React.useState<number>(0);
  const [countryShort, setCountryShort] = useState("");
  const [deliveryMethod, setDeliveryMethod] = React.useState("shipping");
  const [orderStatusOpen, setOrderStatusOpen] = React.useState(false);
  const [orderError, setOrderError] = React.useState(false);
  const [clinetId, setClientId] = useState("");
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = ["Shipping address", "Payment details"];
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const formRef = useRef<FormikProps<PartsCheckoutDetail>>(null);

  useEffect(() => {
    if (customerData && customerData.email) {
      setPartsCheckoutDetail({
        ...partsCheckoutDetail,
        billingName: customerData.displayName,
        email: customerData.email,
        phone: customerData.phone,
      });
    }
  }, [customerData]);
  const handlePlaceOrder = (values: CheckoutDetail) => {
    setErrorMessage("");
    values.transactionReference = "";
    values.amount = amountToPay.toFixed(2);
    values.cashierId = values.billingName;
    if (dmsLocations) {
      values.dmsSetupId = dmsLocations[0].dmsSetupId;
      getTransactionTokenMutation({ data: values });
    }
  };
  const handleOnSubmit = async (values: PartsCheckoutDetail) => {
    setCustomerInformation(values);
    setErrorMessage("");
    let address: DraftOrderAddress = {};
    if (values.method === "shipping") {
      address = {
        firstName: values.firstName,
        lastName: values.lastName ?? "",
        address1: values.address,
        city: values.city,
        phone: values.phone,
        provinceCode: values.state,
        countryCode: countryShort,
        country: values.country,
        zip: values.zip,
      };
    } else if (values.method === "pickup") {
      var selectedLoc = dmsLocations?.find(
        (loc) => loc.id === values.locationId
      );
      var data = await getAddressForAutoFill(
        selectedLoc?.address +
          ", " +
          selectedLoc?.city +
          ", " +
          selectedLoc?.stateOrProvince +
          "," +
          selectedLoc?.zipPostal
      );
      setPickupLocationData(data);
      address = {
        firstName: values.firstName,
        phone: values.phone,
        lastName: values.lastName ?? "",
        address1: data?.formattedAddress,
        city: data?.city,
        provinceCode: data?.state,
        countryCode: data?.countryCode,
        country: data?.country,
        zip: data?.pin,
      };
    }
    if (paymentMethod === "PayPal") {
      handleGetClientId();
    }
    handleCalculateTax(address);
  };
  const getTotalBill = () => {
    return cart.reduce((sum, obj) => sum + obj.price * obj.quantity, 0);
  };

  const handleCreateOrder = (historyId: string) => {
    let address: Address;
    if (customerInformation?.method === "shipping") {
      address = {
        name: getFullName(
          customerInformation.firstName,
          customerInformation.middleName,
          customerInformation.lastName
        ),
        address1: customerInformation.address,
        city: customerInformation.city,
        state: customerInformation.state,
        zip: customerInformation.zip ?? "",
        country: customerInformation.country,
      };
    } else {
      address = {
        name: getFullName(
          customerInformation?.firstName,
          customerInformation?.middleName,
          customerInformation?.lastName
        ),
        address1: pickupLocationData?.formattedAddress,
        city: pickupLocationData?.city,
        state: pickupLocationData?.state,
        zip: pickupLocationData?.pin ?? "",
        country: pickupLocationData.country,
      };
    }

    const taxLines: TaxLines[] = [];
    if (taxResponse && taxResponse.calculatedDraftOrder) {
      taxResponse.calculatedDraftOrder.taxLines.forEach((item: any) => {
        taxLines.push({
          rate: item.rate,
          title: item.title,
          channelLiable: true,
          price: "",
          priceSet: {
            presentmentMoney: {
              amount: item.priceSet.presentmentMoney.amount,
              currencyCode: item.priceSet.presentmentMoney.currencyCode,
            },
            shopMoney: {
              amount: item.priceSet.shopMoney.amount,
              currencyCode: item.priceSet.shopMoney.currencyCode,
            },
          },
        });
      });
    }

    let data: TargetOrderRequest = {
      transactionHistoryId: historyId,
      dmsSetupId: setupId ?? "",
      targetOrderDetail: {
        gateway: paymentMethod === "PayPal" ? "PayPal" : "Gravity",
        totalPrice: amountToPay.toString(),
        totalTax: taxAmount.toFixed(2).toString(),
        shippingCost:
          deliveryMethod === "shipping"
            ? parseFloat(shippingCharges ?? "0.00")
                .toFixed(2)
                .toString()
            : "0.00",
        deliveryMethod: deliveryMethod === "shipping" ? "Shipping" : "Pickup",
        taxesIncluded: true,
        totalDiscounts: "0",
        currency: "usd",
        customer: {
          firstName: customerInformation?.firstName ?? "",
          lastName: customerInformation?.lastName ?? "",
          middleName: customerInformation?.middleName ?? "",
          email: customerInformation?.email,
          phone: customerInformation?.phone,
        },
        address: address,
        shippingLines:
          deliveryMethod === "shipping"
            ? [
                {
                  price: parseFloat(shippingCharges ?? "0.00").toString(),
                  source: "TargetWeb",
                  title: "TargetWeb flat rate",
                  taxLines: [],
                },
              ]
            : [],
        taxLines: taxLines,
        lineItems: cart,
      },
      methodType: customerInformation?.method,
      locationId: customerInformation?.locationId,
    };
    createOrderMutation({ data: data })
      .then((response: any) => {
        if (response?.data && response.data.entity === true) {
        } else {
          setOrderError(true);
        }
        dispatch(removeCart());
        setOrderStatusOpen(true);
      })
      .catch((error) => {
        setOrderError(true);
      });
  };

  const InititatePayment = (transactionToken: string) => {
    emergepay.open({
      transactionToken: transactionToken,
      onTransactionSuccess: (approvalData: any) => {
        (window as any).emergepay.close();
        approvalData.targetCustomerId = "";
        approvalData.orderId = "order from Parts portal";
        addTransactionHistoryMutation({ data: [approvalData] })
          .then((response: any) => {
            handleCreateOrder(response?.data?.entity?.id ?? "");
          })
          .catch((error) => {
            handleCreateOrder("");
          });
      },
      onTransactionFailure: (failureData: any) => {},
      onTransactionCancel: () => {},
    });
  };

  useEffect(() => {
    if (deliveryMethod === "shipping") {
      let shipcharges = parseFloat(shippingCharges ?? "");
      setAmountToPay(taxAmount + getTotalBill() + shipcharges);
    } else {
      setAmountToPay(taxAmount + getTotalBill());
    }
  }, [taxAmount]);

  const handleGetClientId = () => {
    getClientIdMutation({ setupId: setupId }).then((response: any) => {
      if (response && response.data) {
        setClientId(response.data.entity);
      }
    });
  };
  const handleCalculateTax = (address: DraftOrderAddress) => {
    setErrorMessage("");
    const taxRequest: DraftOrderRequest = {
      shippingAddress: address,
      lineItems: cart.map((item: any) => ({
        title: item.inventoryPartId,
        quantity: item.quantity,
        originalUnitPrice: item.price,
        requiresShipping: true,
      })),
    };
    calculateTaxMutation({ data: taxRequest, dmsSetupId: setupId ?? "" })
      .then((response: any) => {
        if (
          response &&
          response?.data.status === 200 &&
          response.data.entity.draftOrderCalculate
        ) {
          var result = response.data.entity.draftOrderCalculate;
          if (result.calculatedDraftOrder !== null) {
            setTaxResponse(response.data.entity.draftOrderCalculate);
            let tax =
              response.data.entity.draftOrderCalculate.calculatedDraftOrder
                .totalTaxSet.presentmentMoney.amount;
            tax = parseFloat(tax);
            setTaxAmount(tax);
            handleNext();
            if (deliveryMethod === "shipping") {
              let shipcharges = parseFloat(shippingCharges ?? "");
              setAmountToPay(tax + getTotalBill() + shipcharges);
            } else {
              setAmountToPay(tax + getTotalBill());
            }
          } else if (result.userErrors.length > 0) {
            setErrorMessage(
              "Unable to sell to this area due to merchant website settings. Please contact the merchant for details"
            );
          } else {
            setErrorMessage("Sorry!, Please try again.");
          }
        } else if (response && response?.data.status === 404) {
          setErrorMessage("Please provide valid address");
        } else {
          setErrorMessage("Sorry!, Please try again.");
        }
      })
      .catch((error) => {
        setErrorMessage("Please provide valid address");
      });
  };

  const handleClose = () => {
    setErrorMessage("");
    setAmountToPay(0);
    setTaxAmount(0);
    setActiveStep(0);
    setOrderStatusOpen(false);
    setOrderError(false);
    dispatch(setOpenCheckout({ isOpen: false }));
  };

  React.useEffect(() => {
    if (
      getTransactionTokenMutationResult.data &&
      getTransactionTokenMutationResult.isSuccess
    ) {
      if (
        getTransactionTokenMutationResult.data &&
        getTransactionTokenMutationResult.data.status === 0
      ) {
        if (
          getTransactionTokenMutationResult.data.entity.transactionToken !==
          null
        ) {
          setActiveStep(0);
          dispatch(setOpenCheckout({ isOpen: false }));
          InititatePayment(
            getTransactionTokenMutationResult.data.entity.transactionToken
          );
        } else {
          setErrorMessage("Sorry, We're not able to start your payment");
        }
      } else {
        setErrorMessage("Sorry, We're not able to start your payment");
      }
    }
  }, [getTransactionTokenMutationResult]);

  const compIsType = (t: any, s: any) => {
    for (let z = 0; z < t.length; ++z) if (t[z] === s) return true;

    return false;
  };
  const getAddress = (id: string) => {
    let location = dmsLocations?.find((loc) => loc.id === id);
    return (
      location?.address +
      ", " +
      location?.city +
      ", " +
      location?.stateOrProvince +
      ", " +
      location?.zipPostal
    );
  };
  const handlePlaceChanged = (place: any) => {
    let placeId = "";
    let country,
      countryCode,
      postalCode,
      street_number,
      route_number,
      state,
      city = "";

    let formattedAddress = "";

    if (place.address_components) {
      formattedAddress = [
        (place.address_components[0] &&
          place.address_components[0].short_name) ||
          "",
        (place.address_components[1] &&
          place.address_components[1].long_name) ||
          "",
      ].join(" ");
    }

    if (place.address_components !== undefined) {
      let addrComp = place.address_components;

      placeId = place.place_id;

      for (let i = 0; i < addrComp.length; ++i) {
        var typ = addrComp[i].types;

        if (compIsType(typ, "administrative_area_level_1")) {
          state = addrComp[i].short_name || "";
        }

        if (compIsType(typ, "locality")) {
          city = addrComp[i].long_name || "";
        }

        if (compIsType(typ, "country")) {
          countryCode = addrComp[i].short_name || "";

          country = addrComp[i].long_name || "";
        }

        if (compIsType(typ, "street_number")) {
          street_number = addrComp[i].long_name || "";
        }

        if (compIsType(typ, "route")) {
          route_number = addrComp[i].long_name || "";
        }

        let postalCodeOBj = addrComp.find((ac: any) =>
          ac.types.includes("postal_code")
        );

        postalCode = postalCodeOBj?.short_name;

        if (state != null && city != null && country != null) break;
      }

      return {
        state,
        city,
        countryCode,
        country,
        postalCode,
        placeId,
        formattedAddress,
      };
    }
  };
  const handleSelect = async (address: any) => {
    let resp = await getAddressForAutoFill(address);
    formRef.current?.setFieldValue("address", resp?.formattedAddress || "");

    setCountryShort(resp?.countryCode?.toLowerCase() ?? "");

    formRef.current?.setFieldValue("zip", resp?.pin || "");
    formRef.current?.setFieldValue("country", resp?.country || "");

    formRef.current?.setFieldValue("state", resp?.state || "");

    formRef.current?.setFieldValue("city", resp?.city || "");

    if (resp?.country) {
      formRef.current?.setFieldTouched("country", false);
    }

    if (resp?.pin) {
      formRef.current?.setFieldTouched("zip", false);
    }

    if (resp?.state) {
      formRef.current?.setFieldTouched("state", false);
    }

    if (resp?.city) {
      formRef.current?.setFieldTouched("city", false);
    }
  };
  const getAddressForAutoFill = async (address: any) => {
    let returnData = {
      formattedAddress: "",

      pin: "",

      country: "",

      countryCode: "",

      city: "",

      state: "",

      placeId: "",
    };

    let resData = geocodeByAddress(address)
      .then((results) => {
        var addressDetails = results[0];
        let data = handlePlaceChanged(addressDetails);

        returnData.city = data?.city ?? "";

        returnData.state = data?.state ?? "";

        returnData.country = data?.country ?? "";

        returnData.countryCode = data?.countryCode ?? "";

        returnData.pin = data?.postalCode;

        returnData.placeId = data?.placeId ?? "";

        returnData.formattedAddress = data?.formattedAddress ?? "";
        return returnData;
      })

      .catch((error) => {});

    return resData;
  };

  const renderFunc = ({
    getInputProps,

    suggestions,

    getSuggestionItemProps,

    loading,
  }: any) => (
    <>
      <div>
        <TextField
          {...getInputProps()}
          name="address"
          type="text"
          label="Address"
          fullWidth
          variant="standard"
          id="address-input"
        />

        <div className="autocomplete-container">
          <div className="autocomplete-dropdown">
            {loading && <div>Loading...</div>}

            {suggestions.map((suggestion: any) => (
              <>
                <Divider sx={{ width: "100%" }} />
                <div
                  key={suggestion.description}
                  {...getSuggestionItemProps(suggestion)}
                >
                  <span onChange={handleSelect} style={{ cursor: "pointer" }}>
                    {suggestion.description}
                  </span>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );

  function PayPal() {
    const createOrder = (data: any, actions: any) => {
      return actions.order.create({
        purchase_units: [
          {
            amount: {
              value: amountToPay.toFixed(2).toString(),
            },
          },
        ],
      });
    };
    const onApprove = (data: any, actions: any) => {
      return actions.order.capture().then(function (details: any) {
        addPayPalTransactionHistoryMutation({ data: [details] })
          .then((res: any) => {
            handleCreateOrder(res?.data?.entity?.id ?? "");
          })
          .catch((err) => {
            handleCreateOrder("");
          });
      });
    };

    return (
      <PayPalScriptProvider
        options={{
          clientId: clinetId,
        }}
      >
        <PayPalButtons
          style={{ layout: "horizontal", label: "pay" }}
          fundingSource="paypal"
          createOrder={createOrder}
          onApprove={onApprove}
        />
      </PayPalScriptProvider>
    );
  }

  return (
    <>
      <Dialog open={openCheckout} maxWidth="sm" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 1,
            paddingBottom: 0,
          }}
        >
          <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
            Checkout Detail
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Formik
          innerRef={formRef}
          initialValues={partsCheckoutDetail}
          enableReinitialize
          validationSchema={PartsCheckoutValidationSchema}
          onSubmit={(values) => {
            handleOnSubmit(values);
          }}
        >
          {({ values, errors, handleChange, handleBlur, setFieldValue }) => (
            <>
              <Form>
                <DialogContent sx={{ paddingTop: 0, paddingBottom: 0 }}>
                  <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
                    {steps.map((label, index: number) => (
                      <Step key={index}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                  {activeStep === 0 ? (
                    <Grid container spacing={3} p={2}>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id="firstName"
                          name="firstName"
                          label="Frist Name"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.firstName}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="firstName"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id="middleName"
                          name="middleName"
                          label="Middle Name"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.middleName}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="middleName"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id="lastName"
                          name="lastName"
                          label="Last Name"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastName}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="lastName"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="email"
                          name="email"
                          label="Email"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          sx={{ marginTop: "-8px" }}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="email"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <PhoneInput
                          country={"us"}
                          preferredCountries={["us", "ca"]}
                          value={values.phone}
                          onChange={(phone) => {
                            phone = `+${phone}`;
                            setFieldValue("phone", phone);
                          }}
                          onBlur={handleBlur}
                          inputStyle={{
                            width: "100%",
                            border: "none",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                            borderRadius: 0,
                            outline: "none",
                            boxShadow: "none",
                          }}
                          containerClass="custom-phone-class"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="phone"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        display="flex"
                        justifyContent="flex-start"
                        flexDirection="column"
                        alignItems="flex-start"
                      >
                        <Typography>Delivery Method:</Typography>
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="radio-buttons-group-label"
                            defaultValue="shipping"
                            name="method"
                            onChange={(params) => {
                              setDeliveryMethod(params.target.value);
                              handleChange(params);
                            }}
                            onBlur={handleBlur}
                            value={values.method}
                          >
                            <FormControlLabel
                              value="shipping"
                              control={<Radio />}
                              label="Shipping"
                            />
                            <FormControlLabel
                              value="pickup"
                              control={<Radio />}
                              label="Pickup"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        display={values.method === "pickup" ? "block" : "none"}
                      >
                        <FormControl component="fieldset" variant="standard">
                          <FormLabel>
                            Please Select The Location for Pickup
                          </FormLabel>

                          <RadioGroup
                            name="locationId"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.locationId}
                          >
                            {dmsLocations?.map((item, index: number) => {
                              return (
                                <React.Fragment key={index}>
                                  <FormControlLabel
                                    value={item.id}
                                    control={<Radio />}
                                    label={item.name}
                                    key={index}
                                  />
                                </React.Fragment>
                              );
                            })}
                          </RadioGroup>
                          <ErrorMessage
                            className="error-msg"
                            component={"div"}
                            name="locationId"
                          />
                        </FormControl>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        display={
                          values.method === "shipping" ? "block" : "none"
                        }
                      >
                        <PlacesAutocomplete
                          searchOptions={searchOptions}
                          value={values.address}
                          onChange={(ev: any) => {
                            setFieldValue("address", ev);
                          }}
                          onSelect={handleSelect}
                        >
                          {renderFunc}
                        </PlacesAutocomplete>
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="address"
                        />
                      </Grid>

                      <Grid
                        item
                        xs={3}
                        display={
                          values.method === "shipping" ? "block" : "none"
                        }
                      >
                        <TextField
                          id="city"
                          name="city"
                          label="City"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.city}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="city"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        display={
                          values.method === "shipping" ? "block" : "none"
                        }
                      >
                        <TextField
                          id="state"
                          name="state"
                          label="State"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.state}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="state"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        display={
                          values.method === "shipping" ? "block" : "none"
                        }
                      >
                        <TextField
                          id="country"
                          name="country"
                          label="Country"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.country}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="country"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        display={
                          values.method === "shipping" ? "block" : "none"
                        }
                      >
                        <TextField
                          id="zip"
                          name="zip"
                          label="Zip/Postal"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.zip}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="zip"
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <>
                      <Typography variant="h6" gutterBottom>
                        Order summary
                      </Typography>
                      <List disablePadding>
                        <ListItem key={1} sx={{ m: 0, px: 0 }}>
                          <ListItemText primary="Order Amount" />
                          <Typography variant="body2">
                            ${getTotalBill().toFixed(2)}
                          </Typography>
                        </ListItem>
                        <ListItem
                          key={2}
                          sx={{
                            display:
                              values.method === "shipping" ? "blobk" : "none",
                            px: 0,
                          }}
                        >
                          <ListItemText primary="Shipping " />
                          <Typography variant="body2">
                            ${parseFloat(shippingCharges ?? "").toFixed(2)}
                          </Typography>
                        </ListItem>
                        <ListItem key={3} sx={{ px: 0 }}>
                          <ListItemText primary="Tax " />
                          <Typography variant="body2">
                            $
                            {calculateTaxMutationResult.isLoading
                              ? "Calculating..."
                              : taxAmount.toFixed(2)}
                          </Typography>
                        </ListItem>
                        <Divider sx={{ width: "100%" }} />
                        <ListItem key={4} sx={{ px: 0 }}>
                          <ListItemText primary="Total " />
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 700 }}
                          >
                            ${amountToPay.toFixed(2)}
                          </Typography>
                        </ListItem>
                      </List>

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                            Customer information
                          </Typography>
                          <Typography gutterBottom>
                            {values?.firstName ?? ""}&nbsp;
                            {values?.middleName ?? ""}&nbsp;
                            {values?.lastName ?? ""}
                          </Typography>
                          <Typography gutterBottom>{values.email}</Typography>
                          <Typography gutterBottom>{values.phone}</Typography>
                          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                            {values.method === "shipping"
                              ? "Shipping Address"
                              : "Pickup Address"}
                          </Typography>
                          <Typography gutterBottom>
                            {values.method === "shipping"
                              ? values.address +
                                ", " +
                                values.city +
                                ", " +
                                values.state +
                                ", " +
                                values.zip +
                                ", " +
                                values.country
                              : getAddress(values.locationId)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </DialogContent>

                <DialogActions
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 1,
                    p: 2,
                  }}
                >
                  {activeStep !== 0 ? (
                    <Button
                      onClick={handleBack}
                      color="primary"
                      variant="contained"
                    >
                      Back
                    </Button>
                  ) : (
                    <Button
                      autoFocus
                      variant="contained"
                      color="error"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  )}
                  <Typography
                    fontSize="0.9rem"
                    color="error"
                    textAlign="center"
                  >
                    {errorMessage}
                  </Typography>
                  {activeStep === steps.length - 1 ? (
                    paymentMethod === "PayPal" ? (
                      <PayPal />
                    ) : (
                      <Button
                        variant="contained"
                        color="success"
                        disabled={getTransactionTokenMutationResult.isLoading}
                        startIcon={
                          getTransactionTokenMutationResult.isLoading ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            ""
                          )
                        }
                        onClick={() => {
                          let data: CheckoutDetail = {
                            billingName:
                              values?.firstName +
                              " " +
                              values?.middleName +
                              " " +
                              values?.lastName,
                            billingAddress:
                              values.method === "shipping"
                                ? values.address +
                                  ", " +
                                  values.city +
                                  ", " +
                                  values.state +
                                  ", " +
                                  values.country +
                                  "," +
                                  values.zip
                                : getAddress(values.locationId),
                            billingPostalCode:
                              values.method === "shipping"
                                ? values.zip
                                : dmsLocations?.find(
                                    (loc) => loc.id === values.locationId
                                  )?.zipPostal ?? "",
                            amount: "",
                            transactionReference: "",
                            cashierId: "",
                          };
                          handlePlaceOrder(data);
                        }}
                      >
                        Next
                      </Button>
                    )
                  ) : (
                    <Button
                      disabled={
                        cart.length <= 0 || calculateTaxMutationResult.isLoading
                      }
                      startIcon={
                        calculateTaxMutationResult.isLoading ? (
                          <CircularProgress size="1.2rem" color="inherit" />
                        ) : (
                          ""
                        )
                      }
                      variant="contained"
                      type="submit"
                      color="primary"
                    >
                      Next
                    </Button>
                  )}
                </DialogActions>
              </Form>
            </>
          )}
        </Formik>
      </Dialog>
      <Dialog
        open={orderStatusOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Order Status</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {!orderError
              ? "Congratulations! Your order has been placed successfully."
              : "Sorry! We got error while creating your order. But stay calm, We have complete track of your transaction and order."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export const searchOptions = {
  types: ["address"],
};
